import _ from 'lodash';

export default {
  methods: {
    getEnumString(label, value) {
      const index = _.findIndex(this.def.fields, { label });
      if (index >= 0) {
        const enumIndex = _.findIndex(
          this.def.fields[index].options,
          { value },
        );
        if (index >= 0) {
          return this.def.fields[index].options[enumIndex].label;
        }
      }
      return `${value}`;
    },
    relatedUser(uid) {
      const index = _.findIndex(this.related.users, { uid });
      if (index >= 0) {
        return this.related.users[index].name;
      }
      return `${uid}`;
    },
    relatedGroup(gid) {
      const index = _.findIndex(this.related.groups, { gid });
      if (index >= 0) {
        return this.related.groups[index].name;
      }
      return `${gid}`;
    },
    relatedProcess(pid) {
      const index = _.findIndex(this.related.processes, { pid });
      if (index >= 0) {
        return `${this.related.processes[index].name} (${this.related.processes[index].path})`;
      }
      return `${pid}`;
    },
  },
};
